module.exports = __webpack_public_path__ + "static/media/data_mining.e834ca77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/data_mining.svg
// module id = 381
// module chunks = 0